import { render, staticRenderFns } from "./shopCheckPaymentFailed.vue?vue&type=template&id=3820f1ec&scoped=true"
import script from "./shopCheckPaymentFailed.vue?vue&type=script&lang=js"
export * from "./shopCheckPaymentFailed.vue?vue&type=script&lang=js"
import style0 from "./shopCheckPaymentFailed.vue?vue&type=style&index=0&id=3820f1ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3820f1ec",
  null
  
)

export default component.exports